import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CommonService } from '../../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { ClubServicesService } from '../../services/club-services.service';
import { CardDetailsService } from '../../services/card-details.service';

@Component({
  selector: 'app-confirmation-cancel',
  templateUrl: './confirmation-cancel.component.html',
  styleUrls: ['./confirmation-cancel.component.scss']
})
export class ConfirmationCancelComponent implements OnInit {


  defaultImage = '../../../../assets/icons/Loading_icon.gif';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private csObj: CommonService,
    private toast: ToastrService,
    private router: Router,
    private dialogRef: MatDialog,
    private auth: AuthService,
    private  spinner: SpinnerVisibilityService,
    private clubServ: ClubServicesService,
  ) { }

  ngOnInit(): void {
  }

  EvenctDeletNo(id:any){
    console.log(id)
    this.clubServ.deleteTeam(id).subscribe(
      () => {
        this.csObj.callEventList(true)
        this.toast.success("Event Canceled successfully");
        // let currentURL = this.router.url
        // this.router.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
        //   this.router.navigate([currentURL]);
        // });
        console.log('Team deleted successfully');
      },
      (error) => {
        console.error('Error deleting team:', error);
        this.toast.error(error.error.error.message);
      }
    );
  }

  EvenctDeletOk(id:any){

    this.clubServ.deleteEventOrders(id).subscribe(
      () => {
        this.toast.success("Event Canceled successfully");
        // let currentURL = this.router.url
        // this.router.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
        //   this.router.navigate([currentURL]);
        // });
        this.csObj.callEventList(true);
      },
      (error) => {
        console.error('Error deleting team:', error);
        this.toast.error(error.error.error.message);
      }
    );
  }

}
